import { useResponsiveValue } from '~/hooks/use-responsive-breakpoint';

export function useSearchFiltersResponsiveValues(styles: any) {
  const useDebounce = false;

  const stackingSwitch = useResponsiveValue(
    {
      mobile: styles?.search_filters_stacking_switch_mobile,
      tablet: styles?.search_filters_stacking_switch_tablet,
      desktop: styles?.search_filters_stacking_switch_desktop,
      largeDesktop: styles?.search_filters_stacking_switch_large_desktop,
    },
    useDebounce
  );

  const arrowsSwitch = useResponsiveValue(
    {
      mobile: styles?.search_filters_arrows_mobile_switch,
      tablet: styles?.search_filters_arrows_tablet_switch,
      desktop: styles?.search_filters_arrows_desktop_switch,
      largeDesktop: styles?.search_filters_arrows_large_desktop_switch,
    },
    useDebounce
  );

  const tabItemSize = useResponsiveValue(
    {
      mobile: styles?.search_filters_tab_size_select_mobile,
      tablet: styles?.search_filters_tab_size_select_tablet,
      desktop: styles?.search_filters_tab_size_select_desktop,
      largeDesktop: styles?.search_filters_tab_size_select_large_desktop,
    },
    useDebounce
  );

  const tabsItemAlignment = useResponsiveValue(
    {
      mobile: styles?.search_filters_tab_alignment_mobile,
      tablet: styles?.search_filters_tab_alignment_tablet,
      desktop: styles?.search_filters_tab_alignment_desktop,
      largeDesktop: styles?.search_filters_tab_alignment_large_desktop,
    },
    useDebounce
  );

  const tabItemInnerAlignment = useResponsiveValue(
    {
      mobile: styles?.search_filters_tab_inner_alignment_mobile,
      tablet: styles?.search_filters_tab_inner_alignment_tablet,
      desktop: styles?.search_filters_tab_inner_alignment_desktop,
      largeDesktop: styles?.search_filters_tab_inner_alignment_large_desktop,
    },
    useDebounce
  );

  const borderParentContainer = useResponsiveValue(
    {
      mobile: styles?.search_filters_parent_border_style_mobile,
      tablet: styles?.search_filters_parent_border_style_tablet,
      desktop: styles?.search_filters_parent_border_style_desktop,
      largeDesktop: styles?.search_filters_parent_border_style_large_desktop,
    },
    useDebounce
  );

  const borderContainer = useResponsiveValue(
    {
      mobile: styles?.search_filters_container_border_style_mobile,
      tablet: styles?.search_filters_container_border_style_tablet,
      desktop: styles?.search_filters_container_border_style_desktop,
      largeDesktop: styles?.search_filters_container_border_style_large_desktop,
    },
    useDebounce
  );

  const parentShadowSwitch = useResponsiveValue(
    {
      mobile: styles?.search_filters_parent_shadow_switch_mobile,
      tablet: styles?.search_filters_parent_shadow_switch_tablet,
      desktop: styles?.search_filters_parent_shadow_switch_desktop,
      largeDesktop: styles?.search_filters_parent_shadow_switch_large_desktop,
    },
    useDebounce
  );

  const shadowSwitch = useResponsiveValue(
    {
      mobile: styles?.search_filters_container_shadow_switch_mobile,
      tablet: styles?.search_filters_container_shadow_switch_tablet,
      desktop: styles?.search_filters_container_shadow_switch_desktop,
      largeDesktop:
        styles?.search_filters_container_shadow_switch_large_desktop,
    },
    useDebounce
  );

  const parentBackgroundBlurSwitch = useResponsiveValue(
    {
      mobile: styles?.search_filters_parent_background_blur_switch_mobile,
      tablet: styles?.search_filters_parent_background_blur_switch_tablet,
      desktop: styles?.search_filters_parent_background_blur_switch_desktop,
      largeDesktop:
        styles?.search_filters_parent_background_blur_switch_large_desktop,
    },
    useDebounce
  );

  const backgroundBlurSwitch = useResponsiveValue(
    {
      mobile: styles?.search_filters_container_background_blur_switch_mobile,
      tablet: styles?.search_filters_container_background_blur_switch_tablet,
      desktop: styles?.search_filters_container_background_blur_switch_desktop,
      largeDesktop:
        styles?.search_filters_container_background_blur_switch_large_desktop,
    },
    useDebounce
  );

  const maxWidthSwitch = useResponsiveValue(
    {
      mobile: styles?.search_filters_container_max_width_switch_mobile,
      tablet: styles?.search_filters_container_max_width_switch_tablet,
      desktop: styles?.search_filters_container_max_width_switch_desktop,
      largeDesktop:
        styles?.search_filters_container_max_width_switch_large_desktop,
    },
    useDebounce
  );

  const blendingSwitch = useResponsiveValue(
    {
      mobile: styles?.search_filters_blending_switch_mobile,
      tablet: styles?.search_filters_blending_switch_tablet,
      desktop: styles?.search_filters_blending_switch_desktop,
      largeDesktop: styles?.search_filters_blending_switch_large_desktop,
    },
    useDebounce
  );

  const horizontalGutter = useResponsiveValue(
    {
      mobile: styles?.search_filters_container_horizontal_gutter_mobile,
      tablet: styles?.search_filters_container_horizontal_gutter_tablet,
      desktop: styles?.search_filters_container_horizontal_gutter_desktop,
      largeDesktop:
        styles?.search_filters_container_horizontal_gutter_large_desktop,
    },
    useDebounce
  );

  const paddingLeft = useResponsiveValue(
    {
      mobile: styles?.search_filters_container_mobile_padding_left,
      tablet: styles?.search_filters_container_tablet_padding_left,
      desktop: styles?.search_filters_container_desktop_padding_left,
      largeDesktop: styles?.search_filters_container_large_desktop_padding_left,
    },
    useDebounce
  );

  const paddingRight = useResponsiveValue(
    {
      mobile: styles?.search_filters_container_mobile_padding_right,
      tablet: styles?.search_filters_container_tablet_padding_right,
      desktop: styles?.search_filters_container_desktop_padding_right,
      largeDesktop:
        styles?.search_filters_container_large_desktop_padding_right,
    },
    useDebounce
  );

  const componentMaxWidth = useResponsiveValue(
    {
      mobile: styles?.search_filters_container_max_width_switch_mobile
        ? styles?.search_filters_container_max_width_mobile
        : undefined,
      tablet: styles?.search_filters_container_max_width_switch_tablet
        ? styles?.search_filters_container_max_width_tablet
        : undefined,
      desktop: styles?.search_filters_container_max_width_switch_desktop
        ? styles?.search_filters_container_max_width_desktop
        : undefined,
      largeDesktop:
        styles?.search_filters_container_max_width_switch_large_desktop
          ? styles?.search_filters_container_max_width_large_desktop
          : undefined,
    },
    useDebounce
  );

  return {
    stackingSwitch,
    arrowsSwitch,
    tabItemSize,
    tabsItemAlignment,
    tabItemInnerAlignment,
    borderParentContainer,
    borderContainer,
    parentShadowSwitch,
    shadowSwitch,
    parentBackgroundBlurSwitch,
    backgroundBlurSwitch,
    maxWidthSwitch,
    blendingSwitch,
    horizontalGutter,
    paddingLeft,
    paddingRight,
    componentMaxWidth,
  };
}
